import(/* webpackMode: "eager" */ "/vercel/path0/src/components/styles/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/lib/supabase/auth-context.tsx");
